module.exports = __webpack_public_path__ + "img/back1.448e1a38.png";